// Temp until backend endpoints are created
export function createClient (user) {
  return new Promise((resolve, reject) => {
    resolve({
      data: {
        id: 10,
        ...user
      }
    })
  })
}

export function updateClient (user, id) {
  return new Promise((resolve, reject) => {
    resolve({
      data: {
        id: id,
        ...user
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/client.js